import React, { Component } from "react";
import { Link } from "react-router-dom";
import Modal from "react-responsive-modal";
import "./product-list-item.css";
import { connect } from "react-redux";
import icon from "./G-icon.png";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
class ProductListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      stock: "InStock",
      quantity: 1,
      image: "",
    };
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  onClickHandle(img) {
    this.setState({ image: img });
  }

  minusQty = () => {
    if (this.state.quantity > 1) {
      this.setState({ stock: "InStock" });
      this.setState({ quantity: this.state.quantity - 1 });
    }
  };

  plusQty = () => {
    if (this.props.product.stock >= this.state.quantity) {
      this.setState({ quantity: this.state.quantity + 1 });
    } else {
      this.setState({ stock: "Out of Stock !" });
    }
  };
  changeQty = (e) => {
    this.setState({ quantity: parseInt(e.target.value) });
  };

  getRatingStar = (item) => {
    let RatingStars = [];
    for (let i = 0; i < 5; i++) {
      if (item.rating >= i + 1) {
        // Full star
        RatingStars.push(
          <i
            className="fa fa-star"
            key={i}
            style={{
              color: "#fa4000",
              fontSize: "1em",
              lineHeight: "1em",
              verticalAlign: "middle",
            }}
          />
        );
      } else if (item.rating > i && item.rating < i + 1) {
        // Partial star (show half based on decimal)
        const percentage = (item.rating - i) * 100;
        RatingStars.push(
          <span
            key={i}
            style={{
              position: "relative",
              display: "inline-block",
              width: "1em",
              height: "1em",
              fontSize: "1em",
              lineHeight: "1em",
              verticalAlign: "middle",
            }}
          >
            {/* Gray background star */}
            <i
              className="fa fa-star"
              style={{
                color: "#dddddd",
                position: "absolute",
                left: 0,
                top: 0,
                width: "100%",
                height: "100%",
                lineHeight: "1em",
                fontSize: "1em",
              }}
            />
            {/* Orange partial foreground star */}
            <i
              className="fa fa-star"
              style={{
                color: "#fa4000",
                width: `${percentage}%`,
                overflow: "hidden",
                position: "absolute",
                left: 0,
                top: 0,
                whiteSpace: "nowrap",
                height: "100%",
                lineHeight: "1em",
                fontSize: "1em",
              }}
            />
          </span>
        );
      } else {
        // Empty star
        RatingStars.push(
          <i
            className="fa fa-star"
            key={i}
            style={{
              color: "#dddddd",
              fontSize: "1em",
              lineHeight: "1em",
              verticalAlign: "middle",
            }}
          />
        );
      }
    }
    return RatingStars.length > 0 ? RatingStars : "No Rating";
  };

  render() {
    const {
      product,
      symbol,
      onAddToCartClicked,
      onAddToWishlistClicked,
      onAddToCompareClicked,
      currency,
    } = this.props;
    const { open } = this.state;

    let RatingStars = [];
    for (var i = 0; i < product.rating; i++) {
      RatingStars.push(<i className="fa fa-star" key={i} />);
    }

    let taka = 0;
    if (currency) {
      taka = currency.taka;
    }

    return (
      <div className="product-box">
        {product.availability ? (
          <>
            <div className="img-wrapper">
              <div
                className="front product-image-collection"
                style={{
                  backgroundImage: `url(${icon})`,
                  backgroundColor: "white",
                  backgroundSize: "130px 130px",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
              >
                {product.availability == "taobao" ? (
                  <Link
                    to={`${process.env.PUBLIC_URL}/${this.props.shop}/${product.id}`}
                  >
                    <img
                      src={`${product.pictures[0]}_200x200.webp`}
                      className="img-fluid product-image-collection"
                      alt=""
                      loading="lazy"
                    />
                  </Link>
                ) : (
                  <Link to={`${process.env.PUBLIC_URL}/product/${product.id}`}>
                    <img
                      src={`${product.pictures[0]}_200x200.webp`}
                      className="img-fluid product-image-collection"
                      alt=""
                      loading="lazy"
                    />
                  </Link>
                )}
              </div>
              <div className="cart-info cart-wrap">
                {product.availability == "taobao" ? (
                  <Link
                    to={`${process.env.PUBLIC_URL}/${this.props.shop}/${product.id}`}
                    title="Add to cart"
                  >
                    <i className="fa fa-shopping-cart" aria-hidden="true" />
                  </Link>
                ) : (
                  <Link
                    to={`${process.env.PUBLIC_URL}/product/${product.id}`}
                    title="Add to cart"
                  >
                    <i className="fa fa-shopping-cart" aria-hidden="true" />
                  </Link>
                )}

                <a
                  onClick={onAddToWishlistClicked}
                  title="Add to Wishlist"
                  style={{ cursor: "pointer" }}
                >
                  <i className="fa fa-heart" aria-hidden="true" />
                </a>
              </div>
            </div>
            <div className="product-detail">
              <div>
                <Link to={`${process.env.PUBLIC_URL}/product/${product.id}`}>
                  <h6
                    style={{
                      color: "black",
                      fontSize: "90%",
                      fontWeight: "bold",
                      marginTop: 5,
                      textTransform: "capitalize",
                      whiteSpace: "nowrap", // 🚫 No wrapping
                      overflow: "hidden", // ✂️ Hide overflow
                      textOverflow: "ellipsis", // … Show ellipsis if overflow
                      marginRight: 5,
                      textAlign: "left",
                      paddingBottom: 0,
                    }}
                    className="product-name"
                  >
                    {product.name}
                  </h6>
                </Link>

                <h5 style={{ color: "#ff4a4e", fontWeight: "bold" }}>
                  ৳{parseInt(product.salePrice * parseFloat(taka))}
                </h5>
                <div style={{ fontSize: "80%" }} className="product-name">
                  Total Sold:{product.totalSold}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    paddingLeft: 5,
                    marginTop: 10,
                    borderTop: "1px solid gainsboro",
                    paddingTop: 5,
                    paddingRight: 5,
                  }}
                >
                  <div
                    style={{ fontSize: 12, marginTop: 4 }}
                    className="shop-name"
                  >
                    {this.getRatingStar(product)}
                  </div>

                  <div
                    style={{
                      fontSize: 11,
                      padding: "3px 7px",

                      borderRadius: 4,
                      background:
                        "linear-gradient(90deg, #fda085 0%, #f6d365 100%)",
                      cursor: "pointer",
                      boxShadow: "0 0 8px rgba(253, 160, 133, 0.6)",
                      transition: "all 0.3s ease-in-out",
                    }}
                    className="view-seller"
                  >
                    {product.rating ? product.rating : "No Rating"}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="img-wrapper">
              <div
                className="front product-image-collection"
                style={{
                  background: "#ebebeb",
                }}
              >
                <Skeleton height={200} />
              </div>
            </div>
            <div className="product-detail">
              <div>
                <div
                  style={{
                    marginTop: 10,
                    width: 70,
                    height: 12,
                    background: "linear-gradient(90deg,#b7b7b7, #f3f3f3 )",
                    borderRadius: 3,
                  }}
                >
                  <Skeleton />
                </div>

                <div
                  style={{
                    marginTop: 10,
                    width: "90%",
                    height: 10,
                    borderRadius: 2,
                    background: "linear-gradient(90deg,#b7b7b7, #f3f3f3 )",
                  }}
                >
                  <Skeleton />
                </div>

                <div
                  style={{
                    marginTop: 10,
                    width: "60%",
                    height: 11,
                    borderRadius: 2,
                    background: "linear-gradient(90deg,#b7b7b7, #f3f3f3 )",
                  }}
                >
                  <Skeleton />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currency: state.user.currency,
  };
};
export default connect(mapStateToProps, null)(ProductListItem);
